import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import { computed, PropType } from 'vue';
import {
  AdSize, Breakpoint, mediaQuery, MediumRectangle,
} from '@/common/adSizes';
import NitroPayAd from '@/components/ads/NitroPayAd.vue';
import { AdUnit } from '@/common/adSlots';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResponsiveNitroPayAd',
  props: {
  config: {
    type: Object as PropType<AdUnit>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const ads = computed(() => {
  const definedBreakpoints = [
    { breakpoint: undefined, sizes: props.config.default },
    { breakpoint: 'sm' as Breakpoint, sizes: props.config.sm },
    { breakpoint: 'md' as Breakpoint, sizes: props.config.md },
    { breakpoint: 'lg' as Breakpoint, sizes: props.config.lg },
    { breakpoint: 'xl' as Breakpoint, sizes: props.config.xl },
    { breakpoint: '2xl' as Breakpoint, sizes: props.config['2xl'] },
  ].filter((breakpoint) => breakpoint.sizes !== undefined);

  return definedBreakpoints
    .map((element, index) => ({
      breakpoint: element.breakpoint,
      sizes: element.sizes,
      mediaQuery: mediaQuery(element.breakpoint, definedBreakpoints[index + 1]?.breakpoint),
    }))
    // Don't render ad blocks without sizes
    .filter((element) => element.sizes?.length);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ads), (ad) => {
      return (_openBlock(), _createBlock(NitroPayAd, {
        key: ad.breakpoint,
        id: `${__props.config.id}-${ad.breakpoint ? ad.breakpoint : 'default'}`,
        "ad-sizes": ad.sizes,
        "media-query": ad.mediaQuery,
        "with-fallback": ad.sizes?.includes(_unref(MediumRectangle))
      }, null, 8, ["id", "ad-sizes", "media-query", "with-fallback"]))
    }), 128))
  ]))
}
}

})